import i8n from "@/i18n";
import { PhpCompatibilityCheck } from "leatherman-js/models";
import store from "@/store";

const handler = (event, data) => {
  switch (event) {
    case "app-phpcompatibilitycheck:add":
    case "app-phpcompatibilitycheck:update":
      store.dispatch(
        "php/refreshCompatibilityCheck",
        PhpCompatibilityCheck.formatWebsocketEvent(data)
      );
      break;
    case "api-task:add":
    case "api-task:update":
      if (data.identity.includes("cloud-account:change-php-version")) {
        if (data.identity.includes("(pending)") || data.identity.includes("(processing)")) {
          store.dispatch("php/addVersionUpdate", data.resource_id);
        }
        if (data.identity.includes("(success)")) {
          store.dispatch("toasts/addToast", {
            variant: "success",
            message: i8n.t("toasts.php-version-update-success-message"),
          });
          store.dispatch("php/removeVersionUpdate", data.resource_id);
        }
        if (data.identity.includes("(rejected)")) {
          store.dispatch("toasts/addToast", {
            variant: "warning",
            message: i8n.t("toasts.php-version-update-incompatibility-message"),
          });
          store.dispatch("php/removeVersionUpdate", data.resource_id);
        }
        store.dispatch("sites/refreshItem", data.resource_id);
        store.dispatch("devSites/refreshItem", data.resource_id);
        break;
      }
  }
};

export default handler;
